export function moveCropRectByDirection({ crop, image, renderRotation, imageRotation, direction, step = 1, }) {
    const totalRotation = ((renderRotation !== null && renderRotation !== void 0 ? renderRotation : 0) + (imageRotation !== null && imageRotation !== void 0 ? imageRotation : 0)) % 360;
    const rotationMap = {
        0: { up: "up", down: "down", left: "left", right: "right" },
        90: { up: "left", down: "right", left: "down", right: "up" },
        180: { up: "down", down: "up", left: "right", right: "left" },
        270: { up: "right", down: "left", left: "up", right: "down" },
    };
    const mapped = rotationMap[renderRotation][direction];
    // Flip dimensions for bounds if rotated 90/270
    const isRotated = totalRotation === 90 || totalRotation === 270;
    const imageWidth = isRotated ? image.height : image.width;
    const imageHeight = isRotated ? image.width : image.height;
    let newX = crop.x;
    let newY = crop.y;
    // Calculate pixel step size from percentage
    const stepX = imageWidth * (step / 100);
    const stepY = imageHeight * (step / 100);
    console.log("Move steps", imageWidth, stepX, stepY);
    console.log("Move stuff", direction, imageWidth, imageHeight, imageWidth, imageHeight);
    switch (mapped) {
        case "left":
            newX = Math.min(imageWidth - crop.width, crop.x + stepX);
            break;
        case "right":
            newX = Math.max(0, crop.x - stepX);
            break;
        case "up":
            newY = Math.min(imageHeight - crop.height, crop.y + stepY);
            break;
        case "down":
            newY = Math.max(0, crop.y - stepY);
            break;
    }
    return {
        x: newX,
        y: newY,
        width: crop.width,
        height: crop.height,
    };
}
